import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import moment from "moment";

class ViewFeedback extends React.Component {
  render() {
    const { data = {}, defaultLanguage } = this.props;
    const lang = language[defaultLanguage];

    return (
      <div className="card-body">
        <table className="table">
          <tbody>
            <tr>
              <th>{lang.name}</th>
              <td>{data.name}</td>
            </tr>
            <tr>
              <th>{lang.email_address}</th>
              <td>{data.email}</td>
            </tr>
            <tr>
              <th>{lang.phone_number}</th>
              <td>{data.phoneNumber}</td>
            </tr>
            <tr>
              <th>{lang.message}</th>
              <td style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {data.message}
              </td>
            </tr>
            <tr>
              <th>{lang.created_at}</th>
              <td>{moment(data.createdAt).format("lll")}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(ViewFeedback);
